import { render, staticRenderFns } from "./RemerciementDonMensuel.vue?vue&type=template&id=242a6b64"
import script from "./RemerciementDonMensuel.vue?vue&type=script&lang=js"
export * from "./RemerciementDonMensuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports